import React from "react";
import PropTypes from "prop-types";
import Panel from "./Panel";

const ExpansionPanel = ({ panels }) => {
	return (
		<>
			{panels.map(({ header = "", content = "" }, index) => (
				<Panel header={header} content={content} key={`${header}--${index}`} />
			))}
		</>
	);
};

ExpansionPanel.propTypes = {
	panels: PropTypes.arrayOf(
		PropTypes.shape({
			header: PropTypes.string,
			content: PropTypes.string,
		}),
	),
};

ExpansionPanel.defaultProps = {
	panels: [],
};

export default ExpansionPanel;
